import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '@frameworks/redux';

import { DashboardState, SupplyData } from '@types';

export const dashboardInitialState: DashboardState = {
  supply: [],
  minted: [],
  available: [],
  isLoading: false,
  error: undefined,
};

const getSupplyData = createAsyncThunk<SupplyData, void, ThunkAPI>(
  'dashboard/getSupplyData',
  async (_, { extra }) => {
    const { services } = extra;
    const { deevyService } = services;

    return await deevyService.getSupplyData();
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: dashboardInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplyData.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(getSupplyData.fulfilled, (state, { payload }) => {
        state.supply = payload.supply;
        state.minted = payload.minted;
        state.available = payload.available;
        state.isLoading = false;
      })
      .addCase(getSupplyData.rejected, (state, { error }) => {
        state.supply = [];
        state.minted = [];
        state.available = [];
        state.isLoading = false;
        state.error = error.message;
      });
  },
});

export const DashboardActions = {
  ...dashboardSlice.actions,
  getSupplyData,
};
export default dashboardSlice.reducer;
